import React from "react"

export const modalWindowContext = React.createContext()